/**
 * Registry for custom add-to-cart flows (multi-step configurators).
 * `AddToCartButton` uses getFlowSlugForProductId to link to the configure flow when needed.
 * Flow UI is rendered in app/add-to-cart/flowComponents.ts (switch per slug; only loaded on that route).
 */

export type CustomAddToCartFlowProps = {
  flowSlug: string
  searchParams: Record<string, string | string[] | undefined>
}

export type CustomAddToCartFlowMetadata = {
  title: string
  description?: string
  productIds: number[]
}

const flowMetadata: Record<string, CustomAddToCartFlowMetadata> = {
  'vorst-bosch': {
    title: 'Configure your V&B Close-Up Pad',
    description: 'Choose your base, inserts, and engraving options.',
    productIds: [18761, 19219, 19216], // Deluxe, Regular, Limited Edition Erdnase
  },
  'hybrid-cup': {
    title: 'Configure your Hybrid Cup',
    description: 'Choose cup finish, sleeves, and optional solid cup.',
    productIds: [29943],
  },
  'add-misc': {
    title: 'Add a misc. item',
    description: 'Replacement or custom-priced line item (staff).',
    productIds: [8640],
  },
}

/**
 * Get flow slug for a product ID, if that product uses a custom add-to-cart flow.
 */
export function getFlowSlugForProductId(productId: number): string | null {
  for (const [slug, meta] of Object.entries(flowMetadata)) {
    if (meta.productIds.includes(productId)) return slug
  }
  return null
}

export function getCustomAddToCartFlowMetadata(flowSlug: string): CustomAddToCartFlowMetadata | null {
  return flowMetadata[flowSlug] ?? null
}
